module.exports = __webpack_public_path__ + "img/no_data.511c12cf.png";